import type { EntitiesToCreateComment } from '@entities/common/Comments/comments';
import { Link } from 'react-router-dom';
import * as st from './styles.module.scss';

type PT = EntitiesToCreateComment & {
  linkValue?: string;
};

export const NewCommentButton = ({ linkValue = 'new', program, article }: PT) => {
  return (
    <Link to={linkValue} state={{ pageTitle: 'Мой отзыв', program, article }} className={st.link}>
      Мой отзыв
    </Link>
  );
};
